import { MODULE_TYPES } from 'EmailData/constants/DefaultModulesConstants';
import { getModuleType } from 'EmailData/constants/DefaultModulesConstants';
const {
  BUTTON,
  RICH_TEXT,
  FOLLOW_ME,
  IMAGE,
  EMAIL_VIDEO,
  EMAIL_CART,
  EMAIL_PRODUCTS,
  FOOTER,
  DIVIDER,
  HTML
} = MODULE_TYPES;
const BASE_MODULES = [BUTTON, RICH_TEXT, FOLLOW_ME, HTML];
const MEDIA_MODULES = [IMAGE, EMAIL_VIDEO];
const STRUCTURE_MODULES = [FOOTER, DIVIDER];
const ECOMMERCE_MODULES = [EMAIL_CART, EMAIL_PRODUCTS];
export const moduleTilesCategorizer = moduleIds => {
  const categories = {
    base: [],
    media: [],
    structure: [],
    ecommerce: []
  };
  moduleIds.forEach(moduleId => {
    const moduleType = getModuleType(moduleId);
    if (BASE_MODULES.includes(moduleType)) {
      categories.base.push(moduleId);
    } else if (MEDIA_MODULES.includes(moduleType)) {
      categories.media.push(moduleId);
    } else if (STRUCTURE_MODULES.includes(moduleType)) {
      categories.structure.push(moduleId);
    } else if (ECOMMERCE_MODULES.includes(moduleType)) {
      categories.ecommerce.push(moduleId);
    }
  });
  return categories;
};